import { FC } from "react";
import styles from "@/css/Loader.module.css";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

type Props = {
  hasContainer?: boolean;
};

export const Loader: FC<Props> = ({ hasContainer }) => {
  const { isLoading } = useLoadingContext();
  const { colors } = useAppColors();

  const loaderContent = (
    <div className={styles.loader}>
      {Array.from({ length: 10 }, (_, i) => (
        <div
          key={i}
          className={styles.bar}
          style={{
            animationDelay: `${i * 0.1}s`,
            backgroundColor: colors.secondary,
          }}
        />
      ))}
    </div>
  );

  return hasContainer ? (
    <div
      className={styles.container}
      style={{
        zIndex: isLoading ? 1000 : 0,
        opacity: isLoading ? 1 : 0,
        backgroundColor: "transparent",
      }}
    >
      {loaderContent}
    </div>
  ) : (
    loaderContent
  );
};
